/**
 * PagePlaceholder — temporary "this page is being ported" surface.
 *
 * Used for routes that exist in the sidebar nav but haven't been
 * rebuilt yet against the new design folder. Renders inside `.content`
 * using only iio.css primitives (`.card`, `.btn-primary`) so it
 * doesn't depend on any pre-pivot stylesheet.
 */
import { Link } from 'react-router-dom';

export function PagePlaceholder({
  title,
  body,
}: {
  title: string;
  body?: string;
}) {
  return (
    <div className="page" id={`page-${title.toLowerCase().replace(/\s+/g, '-')}`} style={{ display: 'block' }}>
      <div className="projects-header">
        <div className="projects-title-row">
          <h1>{title}</h1>
          <div className="projects-stats">Coming soon — porting to the new design.</div>
        </div>
      </div>

      <div className="card" style={{ padding: 32, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 12, opacity: 0.5 }}>
          <i className="ph ph-hourglass-medium" />
        </div>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>
          {title} hasn't been ported yet.
        </div>
        {body ? (
          <div
            style={{
              fontSize: 13,
              color: 'var(--text-secondary)',
              maxWidth: 460,
              margin: '0 auto 16px',
            }}
          >
            {body}
          </div>
        ) : null}
        <Link to="/projects" className="btn-primary" style={{ textDecoration: 'none' }}>
          <i className="ph ph-arrow-left" /> Back to Projects
        </Link>
      </div>
    </div>
  );
}
